export const APP_VERSION='7f39ab126203e70e679ec2bb58ec4b3c42cd2b64';
